<div class="p-16">
  <h1 class="modal-title">
    <i-tabler name="key" class="success-icon"></i-tabler>
    {{ "MODULE_USER_DETAILS.EXPIRING_PASSWORD_TITLE" | translate }}
  </h1>

  <hr class="m-y-20" style="border: 1px solid #CCC;" />

  <div class="success-box">
    <i-tabler name="alert-triangle" class="warning-icon"></i-tabler>
    <div [innerHTML]="'MODULE_USER_DETAILS.EXPIRING_PASSWORD_MESSAGE' | translate:{days: expiringInto}">
    </div>
  </div>

  <div class="warning-box">
    <div [innerHTML]="'MODULE_LOGIN.CHANGE_PASSWORD_SUCCESS_NO_MFA_MESSAGE_2' | translate">
    </div>
  </div>

  <div class="w-100 text-center">
    <mat-checkbox class="m-t-16 m-b-8" [formControl]="dontShowAgainControl">
      {{ 'MODULE_USER_DETAILS.CHANGE_PASSWORD_SUCCESS_NO_MFA_DONT_SHOW_AGAIN' | translate }}
    </mat-checkbox>
  </div>

  <div class="w-100 d-flex justify-content-center m-t-20 gap-16">
    <!-- Chiudi -->
    <a mat-stroked-button color="accent" (click)="close()">
      {{ "MODULE_USER_DETAILS.NOT_NOW" | translate }}
    </a>
    <!-- Secondo bottone -->
    <a mat-stroked-button color="primary" (click)="goToPasswordChange()">
      {{ "MODULE_USER_DETAILS.REFRESH_PASSWORD" | translate }}
    </a>
    <!-- Configura MFA -->
    <a mat-raised-button color="primary" (click)="goToMfaConfig()">
      {{ "MODULE_USER_DETAILS.ACTIVATE_MFA" | translate }}
    </a>
  </div>
</div>